export default __webpack_public_path__ + "static/lframe-calculator-car-loan-repayment-9e1cb5414ebfdd80282067aa7743b17a.webp";